module.exports = __webpack_public_path__ + "img/GOA-logo.ca1bce45.png";